import { makeAutoObservable, runInAction } from 'mobx'
import { cartMobx, productMobx, doProductMobx } from '@mobx/mall'
import { memberMobx } from '@mobxStore'
import ProductAPI from '@api/mallProduct.api'
import { each, uniqBy, keyBy } from '@dt/fe-utils/dist/lodash'

/** 点餐购物车Mobx */
class Favorite {
  constructor () {
    makeAutoObservable(this)
  }
  /** 当前收藏单内的商品 */
  productList: IMallFavoProduct[] = []
  /** 选中的商品 productNo: true */
  selectProductNoMap = {}
  selectProductNoList = []
  /** 当前已选择的商品，以规格平铺拆分 [productNo1_scaleNo1,productNo1_scaleNo2,productNo2_scaleNo1] */
  productToCartList: IMallDoProduct[]

  /** 全部商品 productNo: memberCollectionProductId */
  get productNoToIdMap () {
    return keyBy(this.productList, 'no') as {
      [no: string]: IMallFavoProduct;
    }
  }
  get viewProductListMap () {
    return keyBy(this.productList, 'no')
  }

  /** 收藏商品变动 */
  setFavorite (product: IMallDoProduct) {
    const index = this.productList.findIndex(item => item.no === product.no)
    if (index >= 0) {
      this.delete(product)
    } else {
      this.add(product)
    }
  }

  /** 收藏单内选择规格 */
  setSelectScale (productNo: string, selectScales: IMallScale[]) {
    const index = this.productList.findIndex((item) => productNo === item.no)
    const product = { ...this.productList[index], selectScales }
    this.productList[index] = product
  }

  /** 添加已选择收藏单商品到购物车 */
  addToCart () {
    let products = []
    this.productList.filter((item) => {
      return item.selectScales && item.selectScales.length > 0 && this.selectProductNoMap[item.no]
    }).forEach((item2) => {
      let itemProducts = item2.selectScales.map((scale) => {
        return {
          ...item2,
          cnt: scale.selectCnt,
          scaleNo: scale.no,
        }
      })
      products = [...products, ...itemProducts]
    })
    this.productToCartList = products
    if (products.length) {
      cartMobx.clear()
      cartMobx.addToCart(products)
      this.clearProductScales()
    }
  }

  /** 单选按钮选择 */
  setSelectProduct (productNo: string) {
    this.selectProductNoMap[productNo] = !this.selectProductNoMap[productNo]
    let list = []
    for (let key in this.selectProductNoMap) {
      if (this.selectProductNoMap[key]) {
        list.push(key)
      }
    }
    this.selectProductNoList = [...list]
  }

  init () {
    return ProductAPI.getCollectList({
      memberId: memberMobx.memberInfo?.memberId,
      page: 1,
      limit: 999,
    }).then((res: any) => {
      if (!res.error) {
        let result = res.result ? res.result.items : []
        let productMap = productMobx.noToViewProductMap
        const productList: any[] = []
        result = uniqBy(result, 'productNo')
        each(result, (item) => {
          if (productMap[item.productNo]) {
            productList.push({ ...doProductMobx.pick({ productNo: item.productNo, isReturn: true }), memberCollectionProductId: item.memberCollectionProductId })
          }
        })
        runInAction(() => {
          this.productList = productList
        })
      }
    })
  }

  /** 添加商品到收藏单, 支持doProduct对象 数组集合 */
  async add (product: IMallDoProduct) {
    await ProductAPI.saveCollect({
      memberId: memberMobx.memberInfo?.memberId,
      productNo: product.no,
    }).then((res: any) => {
      if (res.result?.raw?.insertId) {
        let list = [...this.productList]
        list.push({ ...product, memberCollectionProductId: res.result?.raw?.insertId })
        this.productList = [...list]
      }
    })
  }
  /** 删除商品到收藏单, 支持doProduct对象 数组集合 */
  async delete (product: IMallFavoProduct | IMallDoProduct | string) {
    const productNo = typeof product === 'string' ? product : product.no
    let list = [...this.productList]
    const index = list.findIndex(item => item.no === productNo)
    if (~index) {
      let memberCollectionProductId = list[index]?.memberCollectionProductId
      await ProductAPI.deleteCollect({
        memberId: memberMobx.memberInfo?.memberId,
        memberCollectionProductId
      }).then((res) => {
        list.splice(index, 1)
        this.productList = [...list]
        this.setSelectProduct(productNo)
      })
    }
  }
  /** 清除已选规格 */
  clearProductScales () {
    this.productList = this.productList.map((item) => {
      return {
        ...item,
        selectScales: []
      }
    })
    this.selectProductNoMap = {}
    this.selectProductNoList = []
  }
}
export default new Favorite()
